import { useState } from 'react';

import VIPCodeForm, { VIPCodeFormProps } from './components/VIPCodeForm';
import VIPCodeInfo from './components/VIPCodeInfo';
import { SitePricingDiscount } from '../../../store/features/discounts/types';
import { isZeroDiscountAndVipSuccess } from '../../../../../utils/discountValidation';

interface VIPCodeProps<T> extends Omit<VIPCodeFormProps, 'onSuccess'> {
  codeDiscountResult?: SitePricingDiscount;
  onCodeChange?: (vipCode: string) => Promise<T>;
}

export default function VIPCode<T>(props: VIPCodeProps<T>) {
  const { codeDiscountResult, code, onCodeChange, onValidateVipCode } = props;

  const isZeroVipDiscount = isZeroDiscountAndVipSuccess(codeDiscountResult);
  const [manualShowInfo, setManualShowInfo] = useState<boolean | null>(null);

  const showCodeInfo = manualShowInfo ?? (!isZeroVipDiscount && !!code);

  const codeInfoCloseHandler = () => setManualShowInfo(false);

  const successApplyingVipCodeHandler = (vipCode: string) => {
    const show = () => setManualShowInfo(true);
    if (onCodeChange) {
      onCodeChange(vipCode).then(show);
    } else {
      show();
    }
  };

  return (
    <div className="informa-payment-vip-code-widget">
      {showCodeInfo && codeDiscountResult ? (
        <VIPCodeInfo
          code={code}
          onCloseHandler={codeInfoCloseHandler}
          codeDiscountResult={codeDiscountResult}
        />
      ) : (
        <VIPCodeForm
          code={code}
          onSuccess={successApplyingVipCodeHandler}
          onValidateVipCode={onValidateVipCode}
        />
      )}
    </div>
  );
}
